import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import LanguageToggle from '../../../components/feature/LanguageToggle';

export default function Hero() {
  const { t } = useTranslation('common');
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleCTA = () => {
    window.location.href = 'mailto:info@id.iij.com?subject=Factory Connectivity Solution Inquiry';
  };

  return (
    <section className="relative min-h-screen">
      {/* Header */}
      <header
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          scrolled ? 'bg-white shadow-md' : 'bg-white/95 shadow-sm'
        }`}
      >
        <div className="max-w-7xl mx-auto px-8 py-6 flex items-center justify-between">
          <div className="flex items-center gap-4">
            <img
              src="https://static.readdy.ai/image/d4274df8353789ddb57f96b2fb2e8c2d/41e04a64e64671a6d110ea96f1687540.png"
              alt="IIJ Logo"
              className="h-16 w-auto"
            />
            <span className="text-base font-medium text-slate-900">
              {t('header.companyName')}
            </span>
          </div>
          <LanguageToggle />
        </div>
      </header>

      {/* Hero Content */}
      <div className="relative h-screen pt-28">
        <img
          src="https://public.readdy.ai/ai/img_res/3fdab73de0eff6fb7bf969b79ea62360.jpg"
          alt="Factory Connectivity"
          className="absolute inset-0 w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>

        <div className="relative h-full flex items-center justify-center px-8">
          <div className="max-w-4xl mx-auto text-center text-white w-full">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight">
              {t('hero.headline')}
            </h1>
            <p className="text-xl md:text-2xl mb-10 text-gray-100">
              {t('hero.subheadline')}
            </p>
            <button
              onClick={handleCTA}
              className="bg-red-700 hover:bg-red-800 text-white px-10 py-4 rounded-lg text-lg font-semibold transition-colors whitespace-nowrap cursor-pointer"
            >
              {t('hero.cta')}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
